<template>
  <div class="ClueEntry">
    <van-nav-bar fixed title="公告详情" left-arrow @click-left="()=> $router.go(-1)" />
    <div class="mt-5 content-wrapper">
      <b-row>
        <b-col cols="12">
          <b-card class="card-icon-bg card-icon-bg-primary o-hidden">
            <div class="content wrapper">
              <h6 class="card-title text-center">{{content.title}}</h6>
              <p class="text-center">{{content.creationTime}}</p>
            </div>
            <div class="content mt-2">
             {{content.content}}
            </div>
            <div class="content wrapper" v-if="File && content.fileData.length>0">
              <h6 class="mt-4">附件:</h6>
              <div>
                该做什么
                <a href>下载</a>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "InvestMent",
  data() {
    return {
      content:{},
      File:false
    };
  },
  methods: {
 
  },
  created() {
    this.request({
      url: "/v1.0/ThePublic/readContent",
      method: "POST",
      data: {
        id: this.$route.params.id,
      },
    }).then((res) => {
      if (res.success) {
        this.content = res.data;
        this.File=true
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.ClueEntry {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  overflow-x: hidden;
  background-color: rgb(247, 248, 250);
  z-index: 1;
  .content-wrapper {
    background: #ffffff;
  }
}
</style>
